module.exports = __webpack_public_path__ + "img/loader_banner.60eaf91a.jpg";